import React from "react";

export type OrganizationIconProps = React.SVGProps<SVGSVGElement>;

export const OrganizationIcon: React.FC<OrganizationIconProps> = (props) => (
  <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m1.957 5H6.043a11.6 11.6 0 0 0 0 2h3.914a11.6 11.6 0 0 0 0-2M8 3c-.374 0-.875.356-1.313 1.318A7.4 7.4 0 0 0 6.179 6h3.642a7.4 7.4 0 0 0-.508-1.682C8.875 3.356 8.374 3 8 3m1.821 7H6.179c.12.642.295 1.212.508 1.682C7.125 12.644 7.626 13 8 13s.875-.356 1.313-1.318c.213-.47.388-1.04.508-1.682m1.139-1h1.94a5 5 0 0 0 0-2h-1.94a12.6 12.6 0 0 1 0 2M3.1 7a5 5 0 0 0 0 2h1.94Q5 8.51 5 8t.04-1Zm6.862 5.6a5.02 5.02 0 0 0 2.622-2.6h-1.747a8.6 8.6 0 0 1-.614 2.096 5 5 0 0 1-.261.504m.875-6.6h1.747a5.02 5.02 0 0 0-2.622-2.6q.143.242.261.504c.271.597.481 1.31.614 2.096m-4.799 6.6a5 5 0 0 1-.261-.504A8.6 8.6 0 0 1 5.163 10H3.416a5.02 5.02 0 0 0 2.622 2.6M3.416 6h1.747a8.6 8.6 0 0 1 .614-2.096q.118-.262.261-.504A5.02 5.02 0 0 0 3.416 6" />
  </svg>
);

OrganizationIcon.displayName = "OrganizationIcon";

export default OrganizationIcon;
